import { cookieStorage, localStorage } from '@muse-web/storages'

import { EXPERIMENT_MEMBER_COOKIE_NAME, SESSION_ID_KEY } from '../constants/cookieKeys'
import { ANALYTICS_IDS_KEY, MEMBER_EXPERIMENT_FIRST_SESSION_ID_KEY } from '../constants/storageKeys'
import { type TDeviceContext } from '../types/deviceContextTypes'

/**
 * The stored value is compared against the raw session-id cookie, so only a positive numeric string
 * can ever match. Anything else — no cookie at all, or the number this used to persist — counts as
 * "first session unknown" and gets rewritten, which costs one mislabelled session instead of
 * silently never matching again.
 */
const isValidSessionId = (value: unknown): value is string => {
    if (typeof value !== 'string') {
        return false
    }

    const parsed = Number(value)

    return Number.isFinite(parsed) && parsed > 0
}

export const updateMemberFirstSessionId = () => {
    try {
        const sessionId = cookieStorage.get(SESSION_ID_KEY)

        // No cookie: blocked by the browser, or a stand without https — the cookie is Secure.
        if (!isValidSessionId(sessionId)) {
            return
        }

        const oldData = localStorage.get(ANALYTICS_IDS_KEY) as TDeviceContext | null
        const memberExperimentFirstSessionId = localStorage.get(
            MEMBER_EXPERIMENT_FIRST_SESSION_ID_KEY,
        )
        const memberExperimentId = Number(cookieStorage.get(EXPERIMENT_MEMBER_COOKIE_NAME))

        if (
            !isValidSessionId(memberExperimentFirstSessionId) ||
            (oldData && oldData.member_experiment_id !== memberExperimentId)
        ) {
            localStorage.set(MEMBER_EXPERIMENT_FIRST_SESSION_ID_KEY, sessionId)
        }
    } catch {
        // Silently fail in restricted contexts (iframes, privacy modes, etc.)
    }
}
